<mat-form-field
  appearance="outline" 
  [hideRequiredMarker]="true"
  [formGroup]="group"
  [ngClass]="loading ? 'nsc-form-field-loading' : ''"
  subscriptSizing="dynamic"
  [attr.data-label]="placeholder"
>
  <mat-label>{{ placeholder }}</mat-label>
  <mat-select
    #selectRef
    id="{{idx}}"
    [attr.aria-label]="placeholder"
    formControlName="{{ controlName }}"
    autocomplete="off"
    (openedChange)="openedChange($event)"
    (selectionChange)="changeValue($event)" >
    @for (obj of selectObjects; track obj; let gi = $index) {
      <mat-optgroup [label]="obj.label" id="{{idx}}_group_{{gi}}" [attr.aria-label]="obj.label">
        @for (obj2 of obj.options; track obj2; let i = $index) {
          <mat-option 
            id="{{idx}}_{{gi}}_{{i}}" 
            [value]="obj2.value"
            [attr.aria-label]="obj2.value === group.controls[controlName].value ? obj2.name + ' selected' : null">
            {{ obj2.name }}
          </mat-option>
        }
      </mat-optgroup>
    }
  </mat-select>
  <mat-hint aria-live="off">{{ hint }}</mat-hint>
  @if (group.controls[controlName].invalid) {
    <mat-error>Error: {{ hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
  }
</mat-form-field>
<div class="cdk-visually-hidden" role="status" aria-live="polite" aria-atomic="true">
  {{ panelStatusAnnouncement }}
</div>
